<template>
  <v-container>
    <h2 class="flex display-1 text-center mb-5 mt-2" style="color: #084776">Novosti e-učenja Sveučilišta u Mostaru</h2>
    <v-row>
      <v-col class="hidden-xs-only" md="12" sm="12">
        <v-col v-for="(stavka, index) in stavke" :key="index">
          <!-- <v-col  v-for="(item, i) in stavka.lista" :key="i"> -->
          <v-card color="white" class="#084776--text" flat v-if="index%2 == 0">
            <v-row>
              <v-col cols="3">
                <v-img
                    height="200px"
                    v-if="stavka.image"
                    :src="'https://web-admin.sum.ba/api/storage/' + stavka.image"
                ></v-img>
                <v-img v-else height="200px" :src="require('@/assets/img/sum.png')"></v-img>
              </v-col>

              <v-col cols="9">
                <v-card-text primary-title class="pt-0">
                  <div>
                    <!-- <p>{{$route.params.obavijesti}} </p> -->
                    <!-- <router-link v-if="$route.params.obavijesti == 'novosti'" class="link" :to="'/novosti/' + stavka.alias "><h1 class="font">{{stavka.title}}</h1></router-link> -->
                    <router-link class="link" :to="'/novosti/' + stavka.alias ">
                      <h1 style="line-height: 1.2; font-size: 22px;" class="font"><a class="link"
                                                                                     @click="scrollToTop()">{{ stavka.title }}</a>
                      </h1>
                    </router-link>
                    <br>
                    <div class="meni_txt size_font" v-html="stavka.content.slice(0, 450) + '...'"></div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <br>
                <v-card-text>
                  <div>
                    <span class="grey--text" style="font-size: 15px">Objavljeno: {{ stavka.created_at }}</span>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>

          <v-card v-else color="white" class="#084776--text" flat>
            <v-row justify="end">
              <v-col cols="9">
                <v-card-text primary-title class="pt-0 justify-end">
                  <div>
                    <!-- <p>{{$route.params.obavijesti}} </p> -->
                    <!-- <router-link v-if="$route.params.obavijesti == 'novosti'" class="link" :to="'/novosti/' + stavka.alias "><h1 class="font">{{stavka.title}}</h1></router-link> -->
                    <router-link class="link" :to="'/novosti/' + stavka.alias ">
                      <h1 style="line-height: 1.2; font-size: 22px;" class="font"><a class="link"
                                                                                     @click="scrollToTop()">{{ stavka.title }}</a>
                      </h1>
                    </router-link>
                    <br>
                    <div class="meni_txt size_font" style="font-size: 15px" v-html="stavka.content.slice(0, 450) + '...'"></div>
                  </div>
                </v-card-text>
                <v-spacer></v-spacer>
                <br>
                <v-card-text class="justify-end">
                  <div>
                    <span class="grey--text" style="font-size: 15px">Objavljeno: {{ stavka.created_at }}</span>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="3">
                <v-img
                    height="200px"
                    v-if="stavka.image"
                    :src="'https://web-admin.sum.ba/api/storage/' + stavka.image"
                ></v-img>
                <v-img v-else height="200px" :src="require('@/assets/img/sum.png')"></v-img>
              </v-col>
            </v-row>
          </v-card>
          <br>
        </v-col>
      </v-col>

      <v-col class="hidden-sm-and-up" cols="12">
        <v-card
            color="white"
            class="#084776--text"
            flat
            v-for="(stavka, index) in stavke"
            :key="index"
        >
          <v-img
              v-if="stavka.image"
              :src="'https://web-admin.sum.ba/api/storage/' + stavka.image"
              height="200px"
          ></v-img>
          <v-img v-else height="200px" :src="require('@/assets/img/sum.png')"></v-img>
          <v-card-text primary-title>
            <div>
              <router-link class="link" :to="'/objave/'+ alias + '/' + stavka.alias +'/' ">
                <h1 class="font pb-2" style="font-size: 20px"><a class="link"
                                                                 @click="scrollToTop()">{{ stavka.title }}</a></h1>
              </router-link>
              <div class="meni_txt content_text" v-html="stavka.content.slice(0,200) + '...'"></div>
              <br>
              <div>
                <span class="grey--text">Objavljeno: {{ stavka.created_at }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
        <br>
      </v-col>
    </v-row>
    <div class="text-center">
      <a style="text-decoration: none" @click="scrollToTop()">
        <v-pagination
            v-model="page"
            @change="getNovosti()"
            :total-visible="7"
            :length="pagination_num"
            color="#084776"
        ></v-pagination>
      </a>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import {serverBus} from "../main";

export default {
  async mounted() {
    serverBus.$emit("news-change", this.$route.params.alias);
    this.alias = this.$route.params.alias;
    this.getNovosti();
    this.getPaginationNum();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getPaginationNum() {
      let y = {
        postsPerPage: 5,
        categories: ["E-učenje"],
      };

      axios
          .post("https://web-admin.sum.ba/api/web/stranice", y)
          .then(response => {
            this.pagination_num = response.data;
            // console.log(this.pagination_num)
          })
          .catch(error => console.log(error.message));
    },
    getNovosti() {
      let requestBody = {
        page: this.page,
        postsPerPage: 5,
        categories: ["E-učenje"],
      };

      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.stavke = response.data;
          })
          .catch(error => console.log(error.message));
    },

  },
  watch: {
    page: {
      handler() {
        this.getNovosti();
      }
    },
  },
  data: () => ({
    stavke: [],
    pagination_num: 0,
    page: 1,
  })
}
</script>

<style scoped>
.size_font {
  font-size: 14px !important;
}
</style>